import { BenefitInsuranceTemplate } from "../../../types";
import { PGLI_KEY, PLAN_DETAILS } from "../../../utils/constants";
import { AboutPGLI } from "./AboutPGLI";

const { monthlyPremiumFormatted, initiationFeeFormatted, name } =
  PLAN_DETAILS[PGLI_KEY];

export const getPGLIBenefitDetails = (): BenefitInsuranceTemplate => {
  return {
    slug: PGLI_KEY,
    title: name,
    costDescription: (
      <>
        <b>Monthly Premium:</b> {monthlyPremiumFormatted} per month.
        <br /> <br />
        <b>Initiation Fee:</b> A one-time {initiationFeeFormatted} fee is
        charged upon first-time enrollment.
      </>
    ),
    about: <AboutPGLI />,
    regionConfig: {
      mode: "allowlist",
      countries: ["US"]
    }
  };
};
